module.exports = __webpack_public_path__ + "img/base-play.b5587902.png";